
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    AuthService, MiddlewareService, InvestorService, InvestorCustomActionsService,
    InvestorFilesService, UnitFilesService, UnitsService, UnitsCustomService, IncomeService,
    ContractsService, ContractsCustomService, InsurancesService, InsurancesCustomService,
    ExpenseService, PropertyService, PropertyCustomService, UserService,
    CategoryService, CategoryCustomService,
    PaginationService, SummaryService, MonthlyCutService, MonthlyCutCustomService, ConfigService, DashboardService
} from './';
@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        AuthService,
        MiddlewareService,
        InvestorService,
        InvestorCustomActionsService,
        InvestorFilesService,
        UnitsService,
        UnitFilesService,
        UnitsCustomService,
        IncomeService,
        ExpenseService,
        PropertyService,
        PropertyCustomService,
        CategoryService,
        CategoryCustomService,
        ContractsService,
        UserService,
        ContractsCustomService,
        InsurancesService,
        InsurancesCustomService,
        PaginationService,
        SummaryService,
        MonthlyCutService,
        MonthlyCutCustomService,
        ConfigService,
        DashboardService
    ]
})
export class ApiModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_services/api.module.ts